import styled from "styled-components";

// eslint-disable-next-line no-shadow
export enum Axis {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

function getHeight({ axis, size }: { axis: Axis; size: number }) {
  return axis === Axis.HORIZONTAL ? 1 : size;
}
function getWidth({ axis, size }: { axis: Axis; size: number }) {
  return axis === Axis.VERTICAL ? 1 : size;
}

/**
 * From https://www.joshwcomeau.com/react/modern-spacer-gif/
 *
 * The only required prop is size. By default, it produces a square
 * You can also specify a single axis
 *
 * @component
 * @example
 * <Spacer size={16} />
 * <Spacer axis="horizontal" size={32} />
 *
 * @param axis
 * @param size
 */
const Spacer = styled.span`
  display: block;
  width: ${getWidth}px;
  min-width: ${getWidth}px;
  height: ${getHeight}px;
  min-height: ${getHeight}px;
`;
export default Spacer;
